import React from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,
      gcTime: 0,
    },
  },
})

queryClient.setQueryDefaults(["signage"], {
  staleTime: 1000 * 60 * 60 * 5,
})

/**
 * This HOC provides a QueryClient to the wrapped component.
 * @param {React.FC} WrapperComponent
 */
export function withQueryClient<Props extends object>(WrapperComponent: React.ComponentType<Props>) {
  return (props: Props) => (
    <QueryClientProvider client={queryClient}>
      <WrapperComponent {...props} />
    </QueryClientProvider>
  )
}
